import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiTableModule } from '@snelstart/ui-table';
import { FeatureTaxCorporateListComponent } from './tax-corporate-list/feature-tax-corporate-list.component';
import {SharedUiButtonModule} from "@snelstart/ui-button";

@NgModule({
  imports: [CommonModule, SharedUiTableModule, SharedUiButtonModule],
  declarations: [],
  exports: [],
})
export class FeatureTaxCorporateListModule {}
